<template>
    <div class="main-content public-main-content" :class="{'full-page': fullPage}">
        <router-link :to="{name: 'login'}" class="content-heading">
            <img src="/static/logo-black.png" class="login-logo" alt="logo">
        </router-link>
        <main role="main" class="container container-md">
            <router-view></router-view>
        </main>
    </div>
</template>
<script>
    export default {
        mounted() {
            document.body.classList.add('public');
        },
        computed: {
            fullPage() {
                return this.$route.name === 'login';
            }
        },
        methods: {
            login() {
                this.loading = true;
                this.$store.dispatch('account/login', this.user).then(response => {
                    this.$emit('loggedIn');
                    this.loading = false;
                    this.$router.push({name: 'accountCheckPin'});
                }).catch(error => {
                    this.loading = false;

                    if (error.status === 401 && error.data.status === 'Login credentials are invalid') {
                        this.wrongPassword = true;
                    }
                });
            }
        },
        data() {
            return {
                loading: false,
                wrongPassword: false,
                user: {
                    login: '',
                    password: '',
                }
            }
        }
    }
</script>
<style lang="scss">

    .public-main-content {
        max-width: 800px;
        margin: 0 auto;

        &.full-page {
            /*max-width: 500px;*/
        }

        .content-heading {
            display: block;
            text-align: center;

            .login-logo {
                max-width: 100%;
                max-height: 75px;
                margin-bottom: 30px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/public/Public.vue